import React from 'react';
import { Text } from 'react-native';
import NumberFormat from 'react-number-format';

export default function CurrencyFormat({...props}){
  return (
    <NumberFormat 
      value={props.value} 
      displayType={'text'} 
      thousandSeparator={true} 
      prefix={'$'} 
      renderText={value => <Text>{value}</Text>} 
      decimalScale={2}
      fixedDecimalScale={true}
    />
  )
}